import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CRM from "../pages/crm/page";
import Closed from "../pages/closed/page";
import Templates from "../pages/templates/page";
import Login from "../pages/login/page";
import Intake from "../pages/intake/page";
import History from "../pages/history/page";
import DeadDeals from "../pages/dead-deals/page";
import OnHold from "../pages/on-hold/page";
import Admin from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/crm",
    element: <CRM />,
  },
  {
    path: "/closed",
    element: <Closed />,
  },
  {
    path: "/templates",
    element: <Templates />,
  },
  {
    path: "/intake",
    element: <Intake />,
  },
  {
    path: "/history",
    element: <History />,
  },
  {
    path: "/dead-deals",
    element: <DeadDeals />,
  },
  {
    path: "/on-hold",
    element: <OnHold />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
